(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (() => {
    const promos = document.querySelectorAll('[data-launch-promo]');

    if (!promos.length) {
      return;
    }

    const formatUnit = (value) => String(Math.max(value, 0)).padStart(2, '0');

    promos.forEach((promo) => {
      const deadline = new Date(promo.dataset.countdownEnd);
      const statusEl = promo.querySelector('[data-countdown-status]');
      const daysEl = promo.querySelector('[data-countdown-days]');
      const hoursEl = promo.querySelector('[data-countdown-hours]');
      const minutesEl = promo.querySelector('[data-countdown-minutes]');
      const secondsEl = promo.querySelector('[data-countdown-seconds]');

      if (
        Number.isNaN(deadline.getTime()) ||
        !statusEl ||
        !daysEl ||
        !hoursEl ||
        !minutesEl ||
        !secondsEl
      ) {
        return;
      }

      const render = () => {
        const distance = deadline.getTime() - Date.now();

        if (distance <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          statusEl.textContent = 'Offer ended';
          promo.classList.add('bb-promo--expired');
          return;
        }

        const totalSeconds = Math.floor(distance / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysEl.textContent = formatUnit(days);
        hoursEl.textContent = formatUnit(hours);
        minutesEl.textContent = formatUnit(minutes);
        secondsEl.textContent = formatUnit(seconds);
        statusEl.textContent = 'Offer ends in';
        promo.classList.remove('bb-promo--expired');
      };

      render();
      window.setInterval(render, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
